import { html } from '../../../lib/html'
import icon from './icon.js'
import styles from './poll.module.css'

export function renderPoll(poll) {
  if (!poll) {
    return ''
  }
  const pollUrl = process.env.POLL_URL
  const pollId = `nsc:${poll._id}`

  return html` <dh-sg-poll poll-id="${pollId}" poll-url="${pollUrl}" class="${styles.poll}">
    <h2>
      <div class="${styles.label}">${icon}Avstemning</div>
      <div class="${styles.question}">${poll.question}</div>
    </h2>
    <div>
      ${poll.answers.map(
        (answer) => html`<button value="${answer._key}" disabled>${answer.text}</button>`
      )}
    </div>
    <button value="show-answers" disabled>Sjekk svar</button>
  </dh-sg-poll>`
}

export function renderPollResult({ percentage, total, question, alternatives, altId }) {
  return html`
    <h2>
      <div class="${styles.label}">${icon}Avstemning</div>
      <div class="${styles.question}">${question}</div>
    </h2>
    <div>
      <div>
        ${alternatives
          .map((alt) => {
            const hasVoted = !!altId
            const vote = percentage[alt.value] || 0
            let voteType = ''
            if (hasVoted && altId !== alt.value) {
              voteType = styles.other
            }

            return html`<div
              class="${styles.result} ${voteType}"
              style="--vote-percent:${vote}%;"
              tabindex="-1"
            >
              <div role="text">
                ${alt.text}
                <span> ${vote.toFixed(0)}% </span>
              </div>
            </div>`
          })
          .join('')}
      </div>
      <div class="${styles.total}" tabindex="-1">${total} stemmer totalt</div>
    </div>
  `
}
